// Write your code here
import {Component} from 'react'
import './index.css'

class Speedometer extends Component {
  state = {
    speed: 0,
  }

  onIncreaseSpeed = () => {
    const {speed} = this.state
    // console.log(speed)
    if (speed < 200) {
      this.setState(prevState => ({speed: prevState.speed + 10}))
    }
  }

  ecreaseSpeed = () => {
    const {speed} = this.state
    if (speed > 0) {
      this.setState(prevState => ({speed: prevState.speed - 10}))
    }
  }

  render() {
    const {speed} = this.state

    return (
      <div className="main_container">
        <h1 className="heading_1">SPEEDOMETER</h1>
        <div className="image_container">
          <img
            className="image"
            src="https://assets.ccbp.in/frontend/react-js/speedometer-img.png"
            alt="speedometer"
          />
        </div>
        <h2 className="heading_2">Speed is {speed}mph</h2>
        <p className="para">Min Limit is 0mph, Max Limit is 200mph</p>
        <div className="button_container">
          <button
            type="button"
            className="accelerate_button"
            onClick={this.onIncreaseSpeed}
          >
            Accelerate
          </button>
          <button
            type="button"
            className="applybreak_button"
            onClick={this.ecreaseSpeed}
          >
            Apply Brake
          </button>
        </div>
      </div>
    )
  }
}

export default Speedometer
